// Script para detectar país automáticamente y cambiar market/mostrar precios
// Coloca este código antes del </body> en tu theme.liquid

(function() {
  'use strict';
  
  // ============================================
  // CONFIGURACIÓN
  // ============================================
  const config = {
    // Configuración de países y markets
    paises: {
      'CL': {
        nombre: 'Chile',
        moneda: 'CLP',
        simbolo: '$',
        dominio: 'tutienda.cl', // Cambia por tu dominio
        marketHandle: 'chile', // Handle del market en Shopify
        mensaje: '🇨🇱 Estás viendo precios en pesos chilenos',
        redondearPrecios: false // No redondear para Chile
      },
      'CO': {
        nombre: 'Colombia',
        moneda: 'COP',
        simbolo: '$',
        dominio: 'tutienda.com.co', // Cambia por tu dominio
        marketHandle: 'colombia', // Handle del market en Shopify
        mensaje: '🇨🇴 Estás viendo precios en pesos colombianos',
        redondearPrecios: true, // Redondear precios para Colombia
        tipoRedondeo: 1000 // Redondear a los 1000 más cercanos (ej: 286623 → 287000)
        // Otras opciones: 100, 500, 1000, 5000, 10000
      }
    },
    
    // País por defecto si no se detecta
    paisPorDefecto: 'CL',
    monedaBase: 'CLP',
    
    // Opciones de comportamiento
    mostrarPopup: false, // Mostrar popup de confirmación de país
    redirigirAutomaticamente: true, // Redirigir sin preguntar
    recordarEleccion: true, // Guardar elección del usuario
    actualizarTasas: true,
    intervaloActualizacion: 3600000 // 1 hora
  };
  
  // ============================================
  // DETECCIÓN DE PAÍS
  // ============================================
  
  // Función para detectar país usando múltiples métodos
  async function detectarPais() {
    // 1. Verificar si el usuario ya eligió un país
    if (config.recordarEleccion) {
      const paisGuardado = localStorage.getItem('pais_seleccionado');
      if (paisGuardado) {
        console.log(`✓ País guardado: ${paisGuardado}`);
        return paisGuardado;
      }
    }
    
    // 2. Detectar por parámetro URL
    const urlParams = new URLSearchParams(window.location.search);
    const countryParam = urlParams.get('country');
    if (countryParam) {
      console.log(`✓ País desde URL: ${countryParam}`);
      return countryParam;
    }
    
    // 3. Detectar por market activo de Shopify
    if (window.Shopify && window.Shopify.country) {
      console.log(`✓ País desde Shopify Market: ${window.Shopify.country}`);
      return window.Shopify.country;
    }
    
    // 4. Detectar por dominio
    const dominio = window.location.hostname;
    for (const [codigo, datos] of Object.entries(config.paises)) {
      if (dominio.includes(datos.dominio)) {
        console.log(`✓ País detectado por dominio: ${codigo}`);
        return codigo;
      }
    }
    
    // 5. Detectar por geolocalización (API gratuita)
    try {
      const response = await fetch('https://ipapi.co/json/');
      const data = await response.json();
      if (data.country_code) {
        console.log(`✓ País detectado por IP: ${data.country_code}`);
        return data.country_code;
      }
    } catch (error) {
      console.warn('No se pudo detectar país por IP:', error);
    }
    
    // 6. Fallback: usar país por defecto
    console.log(`✓ Usando país por defecto: ${config.paisPorDefecto}`);
    return config.paisPorDefecto;
  }
  
  // ============================================
  // CAMBIO DE MARKET
  // ============================================
  
  function cambiarMarket(codigoPais) {
    const paisConfig = config.paises[codigoPais];
    
    if (!paisConfig) {
      console.log(`País ${codigoPais} no configurado`);
      return;
    }
    
    // Guardar elección del usuario
    if (config.recordarEleccion) {
      localStorage.setItem('pais_seleccionado', codigoPais);
    }
    
    // Agregar parámetro a la URL actual
    const url = new URL(window.location.href);
    url.searchParams.set('country', codigoPais);
    
    // Redirigir con el parámetro de país
    if (url.toString() !== window.location.href) {
      window.location.href = url.toString();
    }
  }
  
  // ============================================
  // POPUP DE SELECCIÓN DE PAÍS
  // ============================================
  
  function mostrarPopupPais(paisDetectado) {
    const paisConfig = config.paises[paisDetectado];
    
    if (!paisConfig) return;
    
    // Verificar si ya se mostró el popup en esta sesión
    if (sessionStorage.getItem('popup_mostrado')) return;
    
    const popup = document.createElement('div');
    popup.id = 'country-popup';
    popup.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0,0,0,0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 99999;
      animation: fadeIn 0.3s ease;
    `;
    
    popup.innerHTML = `
      <div style="
        background: white;
        padding: 30px;
        border-radius: 12px;
        max-width: 400px;
        text-align: center;
        box-shadow: 0 10px 40px rgba(0,0,0,0.2);
      ">
        <h2 style="margin: 0 0 15px 0; font-size: 24px; color: #333;">
          ${paisConfig.mensaje}
        </h2>
        <p style="margin: 0 0 25px 0; color: #666; font-size: 16px;">
          ¿Deseas ver los precios en ${paisConfig.moneda}?
        </p>
        <div style="display: flex; gap: 10px; justify-content: center;">
          <button id="btn-aceptar" style="
            background: #0066cc;
            color: white;
            border: none;
            padding: 12px 30px;
            border-radius: 6px;
            font-size: 16px;
            cursor: pointer;
            font-weight: 500;
          ">
            Sí, cambiar
          </button>
          <button id="btn-cancelar" style="
            background: #f0f0f0;
            color: #333;
            border: none;
            padding: 12px 30px;
            border-radius: 6px;
            font-size: 16px;
            cursor: pointer;
            font-weight: 500;
          ">
            No, gracias
          </button>
        </div>
      </div>
    `;
    
    document.body.appendChild(popup);
    
    // Marcar popup como mostrado
    sessionStorage.setItem('popup_mostrado', 'true');
    
    // Eventos de botones
    document.getElementById('btn-aceptar').addEventListener('click', () => {
      popup.remove();
      cambiarMarket(paisDetectado);
    });
    
    document.getElementById('btn-cancelar').addEventListener('click', () => {
      popup.remove();
      // Guardar que el usuario rechazó el cambio
      localStorage.setItem('pais_seleccionado', config.paisPorDefecto);
    });
  }
  
  // ============================================
  // BARRA DE CAMBIO DE PAÍS (Siempre visible)
  // ============================================
  
  function agregarBarraCambioPais(paisActual) {
    const barra = document.createElement('div');
    barra.id = 'country-selector-bar';
    
    // Detectar si es móvil
    const esMobile = window.innerWidth <= 768;
    
    const paisConfig = config.paises[paisActual] || { nombre: 'Internacional', moneda: config.monedaBase };
    
    if (esMobile) {
      // Versión móvil: Solo banderas - LADO IZQUIERDO
      barra.style.cssText = `
        position: fixed;
        bottom: 10px;
        left: 10px;
        background: white;
        padding: 4px;
        border-radius: 8px;
        box-shadow: 0 4px 20px rgba(0,0,0,0.15);
        z-index: 9999;
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 8px;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        transition: all 0.3s ease;
      `;
      
      barra.innerHTML = `
        ${Object.entries(config.paises).map(([codigo, datos]) => {
          const bandera = codigo === 'CL' ? '🇨🇱' : '🇨🇴';
          const activo = codigo === paisActual;
          return `
            <button 
              data-country="${codigo}" 
              class="country-flag-btn"
              style="
                font-size: 26px;
                background: ${activo ? '#f0f0f0' : 'transparent'};
                border: ${activo ? '2px solid #0066cc' : '2px solid transparent'};
                border-radius: 8px;
                padding: 8px;
                cursor: pointer;
                transition: all 0.2s ease;
                display: flex;
                align-items: center;
                justify-content: center;
              "
              title="${datos.nombre} (${datos.moneda})"
            >
              ${bandera}
            </button>
          `;
        }).join('')}
      `;
    } else {
      // Versión desktop: Texto + selector - LADO IZQUIERDO
      barra.style.cssText = `
        position: fixed;
        bottom: 20px;
        left: 20px;
        background: white;
        padding: 15px 20px;
        border-radius: 8px;
        box-shadow: 0 4px 20px rgba(0,0,0,0.15);
        z-index: 9999;
        display: flex;
        align-items: center;
        gap: 15px;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        transition: all 0.3s ease;
      `;
      
      barra.innerHTML = `
        <span style="font-size: 14px; color: #666;">
          📍 ${paisConfig.nombre} (${paisConfig.moneda})
        </span>
        <select id="country-selector" style="
          padding: 8px 12px;
          border: 1px solid #ddd;
          border-radius: 4px;
          font-size: 14px;
          cursor: pointer;
          background: white;
        ">
          <option value="">Cambiar país</option>
          ${Object.entries(config.paises).map(([codigo, datos]) => {
            const bandera = codigo === 'CL' ? '🇨🇱' : '🇨🇴';
            return `
              <option value="${codigo}" ${codigo === paisActual ? 'selected' : ''}>
                ${bandera} ${datos.nombre} (${datos.moneda})
              </option>
            `;
          }).join('')}
        </select>
      `;
    }
    
    document.body.appendChild(barra);
    
    if (esMobile) {
      // Eventos para botones de bandera
      document.querySelectorAll('.country-flag-btn').forEach(btn => {
        btn.addEventListener('click', (e) => {
          const nuevoPais = e.currentTarget.dataset.country;
          if (nuevoPais && nuevoPais !== paisActual) {
            cambiarMarket(nuevoPais);
          }
        });
        
        // Efecto hover en móvil
        btn.addEventListener('touchstart', function() {
          this.style.transform = 'scale(1.1)';
        });
        btn.addEventListener('touchend', function() {
          this.style.transform = 'scale(1)';
        });
      });
    } else {
      // Evento de cambio de país para desktop
      document.getElementById('country-selector').addEventListener('change', (e) => {
        const nuevoPais = e.target.value;
        if (nuevoPais) {
          cambiarMarket(nuevoPais);
        }
      });
    }
    
    // Redimensionar el widget si cambia el tamaño de pantalla
    window.addEventListener('resize', () => {
      const barraExistente = document.getElementById('country-selector-bar');
      if (barraExistente) {
        barraExistente.remove();
        agregarBarraCambioPais(paisActual);
      }
    });
  }
  
  // ============================================
  // CONVERSIÓN DE PRECIOS
  // ============================================
  
  let tasasCambio = {
    CLP: 1,     // Chile es la moneda base (no se convierte)
    COP: 4.18   // Tasa inicial: 1 CLP = ~4.18 COP (se actualiza automáticamente)
  };
  
  async function actualizarTasasCambio() {
    if (!config.actualizarTasas) return;
    
    try {
      // Usar API más confiable con CLP como base
      const response = await fetch('https://cdn.jsdelivr.net/npm/@fawazahmed0/currency-api@latest/v1/currencies/clp.json');
      const data = await response.json();
      
      if (data && data.clp && data.clp.cop) {
        // Guardar tasa directa de CLP a COP
        tasasCambio.CLP = 1;
        tasasCambio.COP = data.clp.cop;
        
        localStorage.setItem('tasas_cambio', JSON.stringify({
          ...tasasCambio,
          timestamp: Date.now()
        }));
        
        console.log(`✓ Tasas actualizadas desde CLP: 1 CLP = ${tasasCambio.COP} COP`);
        
        // Reconvertir precios solo si no estamos en Chile
        const paisActual = localStorage.getItem('pais_seleccionado');
        if (paisActual !== 'CL') {
          document.querySelectorAll('[data-converted]').forEach(el => {
            el.dataset.converted = '';
          });
          procesarPrecios();
        }
      }
    } catch (error) {
      console.warn('Error actualizando tasas:', error);
      // Fallback: intentar con otra API
      try {
        const response2 = await fetch('https://api.exchangerate-api.com/v4/latest/CLP');
        const data2 = await response2.json();
        if (data2 && data2.rates && data2.rates.COP) {
          tasasCambio.COP = data2.rates.COP;
          console.log(`✓ Tasas actualizadas (API alternativa): 1 CLP = ${tasasCambio.COP} COP`);
        }
      } catch (error2) {
        console.warn('Error con API alternativa:', error2);
        // Usar tasas guardadas en localStorage
        const tasasGuardadas = localStorage.getItem('tasas_cambio');
        if (tasasGuardadas) {
          const tasas = JSON.parse(tasasGuardadas);
          tasasCambio.CLP = tasas.CLP;
          tasasCambio.COP = tasas.COP;
          console.log(`✓ Usando tasas guardadas: 1 CLP = ${tasasCambio.COP} COP`);
        }
      }
    }
  }
  
  function convertirPrecio(precioCLP, monedaDestino) {
    // Si la moneda destino es CLP (Chile), no convertir
    if (monedaDestino === 'CLP') {
      return precioCLP;
    }
    
    // Convertir de CLP a la moneda destino usando la tasa directa
    const tasa = tasasCambio[monedaDestino] || 1;
    const precioConvertido = precioCLP * tasa;
    
    // Retornar el precio completo sin redondear aquí
    return precioConvertido;
  }
  
  function formatearPrecio(precio, simbolo, paisConfig) {
    let precioFinal = parseFloat(precio);
    
    // Aplicar redondeo si está configurado para este país
    if (paisConfig.redondearPrecios && paisConfig.tipoRedondeo) {
      const redondeo = paisConfig.tipoRedondeo;
      precioFinal = Math.round(precioFinal / redondeo) * redondeo;
    } else {
      // Si no se redondea, solo redondear al entero más cercano
      precioFinal = Math.round(precioFinal);
    }
    
    // Formatear con separadores de miles
    return `${simbolo} ${precioFinal.toLocaleString('es-CO')}`;
  }
  
  function procesarPrecios() {
    const paisActual = localStorage.getItem('pais_seleccionado');
    const paisConfig = config.paises[paisActual];
    
    if (!paisConfig) return;
    
    // Si el país es Chile (CL), no hacer conversión
    if (paisActual === 'CL') {
      console.log('✓ País Chile - usando precios originales (CLP)');
      return;
    }
    
    console.log(`🔄 Procesando precios para ${paisConfig.nombre} (${paisConfig.moneda})`);
    if (paisConfig.redondearPrecios) {
      console.log(`📊 Redondeo activado: cada ${paisConfig.tipoRedondeo}`);
    }
    
    const selectores = [
      '.price',
      '.product-price',
      '.money',
      '[data-price]',
      '.price-item',
      '.product__price',
      'span.money'
    ];
    
    selectores.forEach(selector => {
      document.querySelectorAll(selector).forEach(elemento => {
        if (elemento.dataset.converted) return;
        
        const textoOriginal = elemento.textContent || elemento.innerText;
        // Mejorar el regex para capturar números con puntos y comas
        const precioMatch = textoOriginal.match(/[\d.,]+/);
        
        if (precioMatch) {
          // Limpiar el precio: remover puntos de miles y convertir coma a punto
          let precioLimpio = precioMatch[0].replace(/\./g, '').replace(',', '.');
          const precioCLP = parseFloat(precioLimpio);
          
          if (!isNaN(precioCLP) && precioCLP > 0) {
            const precioConvertido = convertirPrecio(precioCLP, paisConfig.moneda);
            const precioFormateado = formatearPrecio(precioConvertido, paisConfig.simbolo, paisConfig);
            
            console.log(`💱 Conversión: ${precioCLP} CLP → ${precioConvertido} ${paisConfig.moneda} → ${precioFormateado}`);
            
            elemento.textContent = precioFormateado;
            elemento.dataset.converted = 'true';
            elemento.dataset.precioOriginal = precioCLP;
          }
        }
      });
    });
  }
  
  // ============================================
  // INICIALIZACIÓN
  // ============================================
  
  async function inicializar() {
    console.log('🌍 Iniciando detección de país...');
    
    // Detectar país
    const paisDetectado = await detectarPais();
    console.log(`País final: ${paisDetectado}`);
    
    // Actualizar tasas de cambio
    await actualizarTasasCambio();
    setInterval(actualizarTasasCambio, config.intervaloActualizacion);
    
    // Si es un país configurado y no está ya en ese market
    if (config.paises[paisDetectado]) {
      const paisActual = localStorage.getItem('pais_seleccionado');
      
      if (!paisActual || paisActual !== paisDetectado) {
        if (config.mostrarPopup && !config.redirigirAutomaticamente) {
          // Mostrar popup de confirmación
          mostrarPopupPais(paisDetectado);
        } else if (config.redirigirAutomaticamente) {
          // Redirigir automáticamente
          cambiarMarket(paisDetectado);
        }
      }
    }
    
    // Procesar precios
    procesarPrecios();
    
    // Agregar barra de cambio de país
    agregarBarraCambioPais(paisDetectado);
    
    // Observer para precios dinámicos
    const observer = new MutationObserver(() => procesarPrecios());
    observer.observe(document.body, { childList: true, subtree: true });
  }
  
  // Ejecutar cuando el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inicializar);
  } else {
    inicializar();
  }
  
})();